import { Button, CircularProgress } from "@mui/material";
import { CheckIcon } from "@/components/common/icons";
import { WaitlistActions } from "@/hooks/waitlist/useAddToWaitlistDialog";

type Client = {
  id: string;
  firstName: string;
  lastName: string;
};

type Props = {
  waitlist: WaitlistActions;
  client?: Client | null;
};

export default function AddToWaitlistButton({ waitlist, client }: Props) {
  const isDisabled =
    !client || waitlist.isWaitlistEntryCreated || waitlist.isLoadingWaitlist;

  const loadingState = waitlist.isLoadingWaitlist;
  const successState =
    waitlist.isWaitlistEntryCreated && !waitlist.isLoadingWaitlist;
  const defaultState =
    !waitlist.isLoadingWaitlist && !waitlist.isWaitlistEntryCreated;

  return (
    <Button
      onClick={waitlist.openWaitlistDialog}
      size="small"
      sx={{ width: "100%" }}
      disabled={isDisabled}
    >
      {loadingState && <LoadingState />}
      {successState && <SuccessState />}
      {defaultState && <DefaultState />}
    </Button>
  );
}

function DefaultState() {
  return "Add client to waitlist";
}

function LoadingState() {
  return (
    <>
      <CircularProgress size={20} />
      <span style={{ marginLeft: 8 }}>Adding to waitlist...</span>
    </>
  );
}

function SuccessState() {
  return (
    <>
      <CheckIcon size={20} />
      <span style={{ marginLeft: 8 }}>Client added to waitlist</span>
    </>
  );
}
